import React from 'react'
import ModalBody from './modal/modal-body'
import { TdesignEducationFilled } from './icons/education'
import { educationList } from '@/data/education'
import { EducationType } from '@/types/data'

type Props = {}

const Education = (props: Props) => {

    return (
        <ModalBody>
            <div className='flex flex-col items-center justify-center gap-y-4 w-full h-full'>
                <div className='flex gap-x-2 text-blue-500'>
                    <TdesignEducationFilled width={24} height={24} />
                    <h1 className='text-lg font-bold uppercase'>Education</h1>
                </div>
                <div className='flex gap-x-4 w-full h-full flex-1'>
                    <div className='flex flex-col gap-y-4 w-full'>
                        {
                            educationList.map((edu: EducationType, index: number) => (
                                <div key={index} className='flex w-full gap-x-4'>
                                    <div className='h-2 w-2 rounded-full bg-blue-500' />
                                    <div className='
                                            flex flex-col flex-1 
                                            gap-y-2 p-3 border-l-3 
                                            border-blue-500/50
                                            hover:rounded-lg hover:border
                                             transition-all
                                            '>
                                        <div className='flex justify-between items-center'>
                                            <span className='text-gray-400 text-sm'>{edu.since}</span>
                                            <span className='text-blue-500 text-sm'>GPAX {edu.gpax}</span>
                                        </div>
                                        <div className='flex gap-x-4 items-center'>
                                            <img src={edu.logo} alt='school logo' className='w-auto h-8'/>
                                            <h1>{edu.name}</h1>
                                        </div>
                                        <span className='text-blue-500'>"{edu.info}"</span>
                                    </div>
                                    
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </ModalBody>
    )
}

export default Education